import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EditorModule } from 'primeng/editor';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-signature-model',
  standalone: true,
  imports: [EditorModule, SharedModule, ReactiveFormsModule],
  templateUrl: './signature-model.component.html',
  styleUrl: './signature-model.component.scss'
})
export class SignatureModelComponent {
  
  @Output() closeDialog = new EventEmitter<void>();
  @Output() updateSignatures = new EventEmitter<string>();
  @Output() editSignatureValue = new EventEmitter<string>();
  @Input() singatureAction: string = 'Create';
  @Input() signatureDataToEdit: any;

  signatureForm: FormGroup;

  constructor(private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.signatureForm = this.fb.group({
      newSignature: ['']
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['signatureDataToEdit'] || changes['singatureAction']) {
      console.log("Signature Data Updated:", this.signatureDataToEdit);
      console.log("Signature Action Updated:", this.singatureAction);
  
      if (this.singatureAction === 'Update' && this.signatureDataToEdit) {
        console.log("Setting Signature Form Value:", this.signatureDataToEdit.signature);
  
       setTimeout(() => {
        if (this.signatureDataToEdit) {
          this.signatureForm.patchValue({
            newSignature: this.signatureDataToEdit
          });
  
          console.log("After PatchValue:", this.signatureForm.value); // Log to verify
  
          // Force Change Detection
          this.cdr.detectChanges();
        } else {
          console.warn("signatureDataToEdit.signature is EMPTY or UNDEFINED");
        }
      }, 20);
      } else if (this.singatureAction === 'Create') {
        this.signatureForm.reset();
        setTimeout(() => {
        this.signatureForm.reset();
          this.cdr.detectChanges();
        } , 10);
      }
    }
  }
  
  handleCloseDialog() {
    // this.signatureForm.reset();
    this.closeDialog.emit();
  }

  saveSignature() {

    if (this.signatureForm.valid) {
      if(this.singatureAction === 'Update') {
        this.editSignatureValue.emit(this.signatureForm.value.newSignature);
      }else{
        this.updateSignatures.emit(this.signatureForm.value.newSignature);
      }
      this.handleCloseDialog();
    }
  }
}
